import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityStepperState } from './stepper.state';

import { entityStepperNext, entityStepperReset } from './stepper.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityStepperNext, (state) => {
    return {
      ...state,
      step: state.step + 1
    };
  }),
  on(entityStepperReset, (state) => {
    return {
      ...state,
      step: 1
    };
  })
);

export function stepperReducer(state: EntityStepperState, action: Action) {
  return reducer(state, action);
}
